import {
  Grid,
  GridColumn,
  GridDetailRowProps,
  GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import GridWrapper from "../../grid/GridWrapper";
import { planoProduitHeaders } from "../../../constante/headers/planoProduitHeaders";
import { Tooltip } from "@mui/material";
import { useGetPlanogrammeProduitsQuery } from "../../../redux/features/cache";
import { Header } from "../../../models/Header";
import parse from 'html-react-parser';
import { CustomCell } from "../../../components/commons/grid-cell/CustomCell";
import { customCellFeed } from "../../../components/commons/grid-cell/cellRegistry";

interface ProductNameHeaderProps extends GridHeaderCellProps {
  children: any;
}

export default function DetaillProduitComponent(props: GridDetailRowProps) {
  const { data: planogrammeProduits } = useGetPlanogrammeProduitsQuery(
    props.dataItem.plano_seq
  );
  
  const HeaderWithTri = (
    props: ProductNameHeaderProps & { tooltip: string }
  ) => {
    let tooltipParagraphs: JSX.Element[] = [];

    if (props.tooltip !== undefined) {
      tooltipParagraphs = (props.tooltip || "")
        .split(/(?=\b\w+:)/)
        .map((segment, index) => <p key={index}>{segment.trim()}</p>);
    }
    const isEmptyTooltip =
      tooltipParagraphs.length === 1 &&
      tooltipParagraphs[0].props.children === "";

    return (
      <>
        {!isEmptyTooltip ? (
          <Tooltip title={parse(props.tooltip)}>
            <span>{props.title}</span>
          </Tooltip>
        ) : (
          <>
            <span>{props.title}</span> {props.children}
          </>
        )}
      </>
    );
  };

  return (
    <GridWrapper>
      <Grid data={planogrammeProduits} reorderable={true} resizable>
        {planoProduitHeaders.map((column: Header, index: any) => (
          column.isDisplayed &&
          (<GridColumn
            headerCell={(props) => (
              <HeaderWithTri {...props} tooltip={column.tooltip ?? ""} />
            )}
            field={column.field}
            key={column.fieldLabel + index}
            title={column.fieldLabel}
            format={column.fieldFormat}
            headerClassName={`${
              column.fieldFormat === "{0:c}" ? "alignRight" : ""
            }`}
            className={`${column.fieldFormat === "{0:c}" ? "alignRight" : ""}`}
            width={column.width}
            cells={{
              data: column.customCell ? customCellFeed(column.customCell) : undefined
            }}
          />)
        ))}
      </Grid>
    </GridWrapper>
  );
}
